import React, { useState, useEffect } from 'react';

// Shuttlecock animation component
const ShuttlecockAnimation = ({ styles }) => {
  const [position, setPosition] = useState(0);
  const [direction, setDirection] = useState(1); // 1 for right, -1 for left
  
  useEffect(() => {
    const animationInterval = setInterval(() => {
      setPosition(prev => {
        if (prev > 90) {
          setDirection(-1);
          return 90;
        } else if (prev < 10) {
          setDirection(1);
          return 10;
        }
        return prev + (direction * 2);
      });
    }, 50);
    
    return () => clearInterval(animationInterval);
  }, [direction]);
  
  return (
    <div className={styles.shuttlecock} style={{ left: `${position}%` }}>
      <div className={styles.shuttlecockHead}></div>
      <div className={styles.shuttlecockFeathers}></div>
    </div>
  );
};

export default ShuttlecockAnimation;
